import { Component, Input, Output, EventEmitter, OnChanges} from '@angular/core';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { FieldTypeTextMultilineComponent } from '../../../shared/components/field-type-text/field-type-text-multiline/field-type-text-multiline.component';
import { FieldTypeTextSimpleComponent } from '../../../shared/components/field-type-text/field-type-text-simple/field-type-text-simple.component';
import { FieldTypeListSimpleComponent } from '../../../shared/components/field-type-list/field-type-list-simple/field-type-list-simple.component';
import { FormsModule } from '@angular/forms';
import { FieldTypeSwitchComponent } from "../../../shared/components/field-type-switch/field-type-switch.component";
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { CustomizeFieldsSwitchFormComponent } from "../customize-fields-switch-form/customize-fields-switch-form.component";
import { CustomizeFieldsFactory } from '@shared/factories/customize-fields/customize-fields.factory';

@Component({
    selector: 'customize-field-text',
    templateUrl: './customize-field-text.component.html',
    standalone: true,
    imports: [
      FormsModule,
      FieldTypeListSimpleComponent,
      FieldTypeTextSimpleComponent,
      FieldTypeTextMultilineComponent,
      FieldTypeSwitchComponent,
      AfTranslatePipe,
      CustomizeFieldsSwitchFormComponent
    ]
})
export class CustomizeFieldTextComponent implements OnChanges {
  customizeFieldText: any = {
    contentTypeList: this.customizeFieldsFactory.getContentTypeList(),
    defaultValueInfo: {
      id:this.commonUtilsService.createId(),
      label: this.translate.instant('customize.default-value'), //'Valor por defecto',
      maxLength: 500
    },
    contentTypeInfo: {
      id:this.commonUtilsService.createId(),
      label: this.translate.instant('customize.type-content'), //'Tipo de contenido',
    },
    voiceRecordInput:{
      label: this.translate.instant('customize.voice-record-accept-text'),
      required: true
    },
  }

  constructor(
    private translate: AfTranslateFactory,
    private commonUtilsService: CommonUtilsService,
    private customizeFieldsFactory: CustomizeFieldsFactory) { }
  @Input() field: any = null;
  @Input() isPrivate: any = null;
  @Input() hiddenInLandings: boolean = false;
  @Input() concept: any = {};
  @Input() fieldContainer: any;
  @Input() typeView: string = 'normal';
  @Input() previewMode: boolean = false;
  @Input() disabledFormTranslations: any = []

  ngOnChanges(): void {
    let that: any = this.customizeFieldText;
    that.disabledFormConfiguration = this.previewMode || this.concept?.disabled;
    if(this.field){
      that.field = this.field;
      that.contentTypeInfo.noEditable = that.field.noEditable;
      that.field.voiceRecordOk = that.field.isVoiceRecord && that.field.voiceRecordOkText;
    }
    that.field.requiredFields = that.field.isVoiceRecord && that.field.voiceRecordOk;
    // if(this.concept){
    //   if(!this.concept.communicationChannel){
    //     this.customizeFieldText.field.voiceRecordOk = false;
    //     this.customizeFieldText.field.voiceRecordOkText = '';
    //     this.customizeFieldText.field.isVoiceRecord = false;
    //   }
    // }
    if(this.previewMode || (this.concept?.poll && this.concept?.disabled)){
      that.contentTypeInfo.noEditable = true;
      that.defaultValueInfo.noEditable = true;
      that.voiceRecordInput.noEditable = true;
    }
    if (this.disabledFormTranslations.includes('defaultValue')) {
      that.defaultValueInfo.noEditable = true;
    }
    if (this.disabledFormTranslations.includes('voiceRecordOk')) {
      that.voiceRecordInput.noEditable = true;
    }
  }

  itemSelected(e: any, item:any){
      let newValue:any = e.newValue;
      this.customizeFieldText.field[item] = newValue;
      if(item === 'fieldContentTypeId'){
        this.configureContentTypeId(newValue, item);
      }else if(item === 'isVoiceRecord' || item === 'voiceRecordOk'){
        this.customizeFieldText.field.requiredFields = this.customizeFieldText.field.isVoiceRecord && this.customizeFieldText.field.voiceRecordOk;
      }
  }

  configureContentTypeId(newValue: any, item:any){
    if(this.concept?.allowPublicShare && this.customizeFieldText.field.fieldContentTypeId === 'emai' && this.typeView !== 'channelView'){
      this.customizeFieldText.field.isIdentifier = newValue === 'emai' && !this.fieldContainer.multiple;
    }
    if (newValue === 'addr') {
      this.customizeFieldText.field.multiline = false;
    }
  }

  validateSave() {
    let that: any = this.customizeFieldText;
    if (that.field.fieldContentTypeId === 'addr' && (that.field.defaultValue != null && that.field.defaultValue != '' && ! this.commonUtilsService.validateURL(that.field.defaultValue))) {
      that.defaultValueInfo.error = true;
      return false;
    } else if(that.field.voiceRecordOk && !that.field.voiceRecordOkText){
      that.voiceRecordInput.error = true;
      return false;
    }
    return true;
  }
}

